import { PayloadAction, createAction, createSlice } from '@reduxjs/toolkit';
import { UserInfo } from 'src/common/commonTypes';
import { AppState } from 'src/store/store';

const initialState = null as UserInfo | null;

export const userLogoutAction = createAction('USER_LOGOUT');

const slice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {
        userLoggedIn: (_, action: PayloadAction<UserInfo>) => action.payload
    }
});

export const { userLoggedIn } = slice.actions;

export const selectUserInfo = (state: AppState) => state.userInfo;

export const selectUserRole = (state: AppState) => selectUserInfo(state)?.userRole;

export default slice.reducer;
